import { IMaintenanceEvent } from '@/pages/Calendar/calendar.types'
import MaintenanceEventTypeLabel from '@/pages/Calendar/CalendarWeekView/components/MaintenanceEventTypeLabel/MaintenanceEventTypeLabel'
import equipmentUtils from '@/pages/Equipment/equipment.utils'
import timeUtils from '@/utils/time.utils'
import userUtils from '@/pages/User/user.utils'
import useEquipment from '@/pages/Equipment/hooks/useEquipment'
import useResponsibleUsers from '@/pages/Calendar/SidePages/CalendarSidePage/hooks/useResponsibleUsers'
import Skeleton from '@/shared/Loaders/Skeleton'
import LinkIcon from '@/assets/icons/externalLink.svg?react'
import css from './maintenanceEventListItem.module.css'

interface IProps {
  maintenanceEvent: IMaintenanceEvent
  onClick: (date: Date) => void
}

const MaintenanceEventListItem = (props: IProps) => {
  const equipment = useEquipment(props.maintenanceEvent.metadata.equipmentId)
  const { responsibleUsers, loading } = useResponsibleUsers(props.maintenanceEvent.metadata.responsibleUsers)

  const renderResponsibleUsers = () => {
    const text = responsibleUsers
      ?.map((item) => userUtils.getShortName(item.userInfo))
      .filter(Boolean)
      .join(', ')

    return (
      <span className="text-sm text-secondary-strong line-clamp text-pre">{text || 'Ответственный не назначен'}</span>
    )
  }

  if (!equipment) return null

  return (
    <div className={css.wrapper} onClick={() => props.onClick(new Date(props.maintenanceEvent.ts))}>
      <LinkIcon />
      <div className="inline-flex-gap gap8" style={{ alignItems: 'start' }}>
        <MaintenanceEventTypeLabel eventType={props.maintenanceEvent.type} />
        {props.maintenanceEvent.metadata.responsibleUsers.length === 0 &&
          props.maintenanceEvent.type === 'OVERDUE_MAINTENANCE' && (
            <MaintenanceEventTypeLabel eventType={'NO_RESPONSIBLE'} />
          )}
      </div>
      <span className="text-nm line-clamp text-pre" style={{ textAlign: 'left', flexShrink: 0 }}>
        {equipmentUtils.getEquipmentAddress(equipment.location, {
          includeLocationDescription: true,
          includeCountry: false,
        })}
      </span>
      <div className="inline-flex-gap gap8 center">
        <div className="text-sm text-secondary-strong line-clamp text-pre">{`${timeUtils.formatDate(props.maintenanceEvent.ts, 'dd.MM.yyyy')} (±3 дня)`}</div>
        <div className={css.divider} />
        <div>{loading ? <Skeleton height="16px" width="74px" /> : renderResponsibleUsers()}</div>
      </div>
    </div>
  )
}

export default MaintenanceEventListItem
